import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  startIcon: {
    marginRight: -4
  },
  btnText2: { fontWeight: 500, color: theme.palette.primary.contrastText },
  btnContainer: { display: 'flex', gap: 8 },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    color: 'pink'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  }
}))

export default useStyles
